import React from 'react'

const IconClose: React.FunctionComponent = () => {
  return <>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Z" />
      <path fillRule="evenodd" clipRule="evenodd" d="M8 10.033 5.566 12.5 3.5 10.407 5.934 7.94 3.618 5.593 5.684 3.5 8 5.847 10.316 3.5l2.066 2.093-2.316 2.347 2.434 2.467-2.066 2.093L8 10.033Z" fill="#fff" />
    </svg>
  </>
}

export default IconClose